
// 隐私政策
import {computed, defineComponent, reactive, toRefs} from "vue";
import Protocol from '@/components/ProtocolSet.vue'

interface IState {
  detail: string
  loading: boolean,
}

export default defineComponent({
  name: "ProtocolDetail",
  components: {Protocol},
  setup() {
    const state = reactive({
      activeKey: 'service',
      loading: false,
      // courier_service(用户协议)，courier_welfare(司机福利)，courier_privacy(隐私政策)，courier_settled(入驻协议)
      tabs: [
        {
          name: '服务协议',
          id: 'service'
        },
        {
          name: '隐私协议',
          id: 'privacy'
        },
        {
          name: '售后协议',
          id: 'after_sale'
        }
      ]
    })

    const title = computed(() => {
      return state.tabs.find(e => e.id === state.activeKey)?.name || '协议配置'
    })

    const setActive = (key: string) => {
      state.loading = true
      setTimeout(() => {
        state.activeKey = key
        state.loading = false
      }, 10)
    }

    return {
      ...toRefs(state),
      title,
      setActive,
    }
  }
})
